export default "__VITE_ASSET__FRzF5O6n__"